import { atom } from "jotai";

export const isNavbarOpenAtom = atom(true);
